import React from 'react';

export default function TenderBox({
  date,
  title,
  dateTo,
  documentation,
  active
}) {
  return (
    <div className="tender-box">
      <br />
      <label className="tender-box-highlight ">{date}</label>
      <br />
      <label>
        {' '}
        <span className="tender-box-highlight ">Predmet nabavke:</span> {title}
      </label>
      <br />
      <label>
        <span className="tender-box-highlight ">Rok za podnošenje ponuda:</span>{' '}
        {dateTo}
      </label>
      <br />
      <label>
        <span className="tender-box-highlight ">
          Konkursnu dokumentaciju za podnošenje ponude možete preuzeti
        </span>{' '}
        <a href={documentation} download className="font-weight-bold">
          {' '}
          OVDE
        </a>
      </label>
      {active && (
        <div>
          <br />
          <span className="green-circle"></span>
          <label className="tender-box-highlight ml-3"> Aktivan</label>
        </div>
      )}
      {!active && (
        <div>
          <br />
          <span className="red-circle"></span>
          <label className="tender-box-highlight ml-3">Isteklo</label>
        </div>
      )}
    </div>
  );
}
